import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { hotelProviderName } from '@/lib/hotels/vendor';

/**
 * Source-of-inventory badge for hotel rows — every list that shows a hotel
 * shows which provider it came from (ETG, Sabre, direct contract, the mock
 * provider…), by the provider's own name on the Proveedores screen. A mock
 * provider is still a provider: same tone, its name says what it is. Renders
 * nothing when the URN carries no vendor tail (older rows) — absence of an
 * answer, not a wrong one.
 */
export function HotelVendorBadge({
  urn,
  className,
}: {
  /** Any vendor-stamped URN — `hotelUrn` or `offerUrn`. */
  urn: string | null | undefined;
  className?: string;
}) {
  const { t } = useTranslation('network');
  const { t: tCommon } = useTranslation('common');
  const name = hotelProviderName(t, urn);
  if (!name) return null;
  return (
    <Badge
      variant="neutral"
      size="sm"
      className={className}
      title={tCommon('hotelProvider.title', { name })}
      data-testid="hotel-vendor-badge"
    >
      {name}
    </Badge>
  );
}
